import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=0e68c398&scoped=true&"
import script from "./CompanyCard.vue?vue&type=script&lang=js&"
export * from "./CompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=0e68c398&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68c398",
  null
  
)

export default component.exports